import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Box, useTheme } from '@mui/material'
import moment from 'moment'

/**
 * Renders a grid background with vertical dashed lines every 2 hours.
 * @param {object} props
 * @param {moment.Moment} props.windowStart - Start of the time window.
 * @param {moment.Moment} props.windowEnd - End of the time window.
 */
const GridBackground = ({ windowStart, windowEnd }) => {
  const theme = useTheme()
  const windowMs = windowEnd.diff(windowStart)
  const hours = []
  const current = moment(windowStart).startOf('hour')

  // Align to even hours for visual consistency
  if (current.hour() % 2 !== 0) current.add(1, 'hour')

  while (current.isBefore(windowEnd)) {
    if (current.isSameOrAfter(windowStart)) hours.push(moment(current))
    current.add(2, 'hours')
  }

  return (
    <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, pointerEvents: 'none' }}>
      {hours.map((hour, i) => {
        const leftPct = ((hour.valueOf() - windowStart.valueOf()) / windowMs) * 100
        return (
          <Box
            key={i}
            sx={{
              position: 'absolute',
              left: `${leftPct}%`,
              top: 0,
              bottom: 0,
              borderLeft: `1px dashed ${theme.palette.divider}`,
              opacity: 0.15
            }}
          />
        )
      })}
    </Box>
  )
}

GridBackground.propTypes = {
  windowStart: PropTypes.object.isRequired,
  windowEnd: PropTypes.object.isRequired
}

export default memo(GridBackground)
